// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.74a8e3c89',
  revision: '74a8e3c89',
  branch: 'develop',
  date: 'Mon, 12 Oct 2026 10:11:52 GMT'
};